module.exports = __webpack_public_path__ + "static/image/service/m/cartoon@3x.jpg?5ca993f4";